module.exports = __webpack_public_path__ + "media/images/footer-logo-928680ca5a3b7c8cc9fdea764f38f255.svg";